import { render, staticRenderFns } from "./productCommentForm.vue?vue&type=template&id=d44ed1ae"
import script from "./productCommentForm.vue?vue&type=script&lang=js"
export * from "./productCommentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports